import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Clock, BookOpen } from "lucide-react";
import api from "../lib/api";

export default function BlogList() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = "Blog déménagement — conseils et guides | Déménageur Pro";
    const desc = "Guides pratiques, prix indicatifs et conseils pour bien préparer votre déménagement. Articles rédigés par des professionnels du déménagement en France.";
    let m = document.querySelector('meta[name="description"]');
    if (!m) { m = document.createElement("meta"); m.setAttribute("name", "description"); document.head.appendChild(m); }
    m.setAttribute("content", desc);
    let c = document.querySelector('link[rel="canonical"]');
    if (!c) { c = document.createElement("link"); c.setAttribute("rel", "canonical"); document.head.appendChild(c); }
    c.setAttribute("href", `${window.location.origin}/blog`);

    api.get("/blog/posts").then((r) => setPosts(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="animate-fade-up" data-testid="blog-list-page">
      <section className="bg-gradient-to-b from-[#F7F9FB] to-white py-16 md:py-24">
        <div className="container mx-auto px-6 lg:px-10 max-w-5xl">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#E8FBF3] text-[#1AA66C] text-xs font-semibold mb-4">
            <BookOpen className="w-3.5 h-3.5" /> Blog Déménageur Pro
          </div>
          <h1 className="font-heading font-extrabold text-4xl md:text-6xl tracking-tight text-[#2C3E50] leading-tight mb-4" data-testid="blog-list-h1">
            Conseils et guides<br/>déménagement
          </h1>
          <p className="text-lg text-[#6B7280] max-w-2xl">
            Nos articles pratiques pour bien préparer votre déménagement, comparer les devis
            et éviter les erreurs classiques. Rédigés à partir de retours d'expérience réels.
          </p>
        </div>
      </section>

      <section className="py-12 md:py-16 bg-white">
        <div className="container mx-auto px-6 lg:px-10 max-w-5xl">
          {loading && <div className="text-center text-sm text-[#6B7280]">Chargement…</div>}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-testid="blog-grid">
            {posts.map((p) => (
              <Link
                key={p.slug}
                to={`/blog/${p.slug}`}
                className="group block bg-white border border-[#E5E7EB] hover:border-[#2BD391] rounded-3xl p-6 md:p-8 transition-all hover:shadow-lg"
                data-testid={`blog-card-${p.slug}`}
              >
                <div className="flex items-center gap-2 text-[10px] uppercase tracking-widest text-[#6B7280] font-bold mb-3">
                  <span className="px-2 py-0.5 bg-[#F7F9FB] rounded-full">{p.category}</span>
                  <Clock className="w-3 h-3 ml-1" /> {p.reading_time} min
                </div>
                <h2 className="font-heading font-extrabold text-xl md:text-2xl text-[#2C3E50] leading-tight mb-3 group-hover:text-[#1AA66C] transition-colors">
                  {p.title}
                </h2>
                <p className="text-sm text-[#6B7280] leading-relaxed line-clamp-3 mb-4">{p.excerpt}</p>
                <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#2BD391] group-hover:gap-2.5 transition-all">
                  Lire l'article <ArrowRight className="w-3.5 h-3.5" />
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-12 md:py-16 bg-[#F7F9FB]">
        <div className="container mx-auto px-6 lg:px-10 max-w-3xl text-center">
          <h2 className="font-heading font-extrabold text-3xl md:text-4xl text-[#2C3E50] mb-4">Prêt à obtenir des devis ?</h2>
          <p className="text-[#6B7280] mb-6">Un formulaire, plusieurs devis auprès de nos entreprises partenaires. Sans engagement.</p>
          <Link to="/devis" className="btn-primary btn-large" data-testid="blog-list-cta">
            Demander un devis gratuit <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>
    </div>
  );
}
